import { useEffect, useState } from 'react'
import { ReviewsListStore } from 'pages/reviews/store'
import { ReviewsListContext } from 'pages/reviews/context'
import { ReviewsListContent } from 'pages/reviews/pages/all/ui/ReviewsListContent/ReviewsListContent'

export const ReviewsList = () => {
  const [store] = useState(() => new ReviewsListStore())

  useEffect(() => {
    store.init()

    return () => {
      store.dispose()
    }
  }, [])

  return (
    <ReviewsListContext.Provider value={store}>
      <ReviewsListContent />
    </ReviewsListContext.Provider>
  )
}
